const { useCallback, useEffect, useMemo, useRef, useState } = React

const PRICE_KEY = 'sort_by'
const ASSEMBLY_YES_TITLE = 'Yes, please'
const ASSEMBLY_NO_TITLE = 'No, thanks'

const useClickOutside = (isHandled, onClickOut, onClickIn ) => {
  const ref = useRef()

  const handleDocumentClick = useCallback(
    (event) => {
      const isTouch = event.type === 'touchend'

      if (event.type === 'click' && isTouch) {
        return false
      }

      if (!ref?.current?.contains(event.target) && isHandled) {
        onClickOut(event)
      }

      return true
    },
    [onClickOut, isHandled]
  )

  const onClick = (e) => {
    if (onClickIn) {
      onClickIn(e)
    }
  }

  useEffect(() => {
    document.addEventListener('touchend', handleDocumentClick, true)
    document.addEventListener('click', handleDocumentClick, true)

    return () => {
      document.removeEventListener('touchend', handleDocumentClick, true)
      document.removeEventListener('click', handleDocumentClick, true)
    }
  })

  return { onClick, ref }
}

function convertSchemaToHtml(schema, scoped = false) {
  if (typeof schema === 'string' || schema instanceof String) {
    schema = JSON.parse(schema)
  }
  let html = ``
  if (schema.type === 'root' && schema.children.length > 0) {
    if (scoped) {
      html += `
      <div class="${scoped === true ? `rte` : scoped}">
        ${convertSchemaToHtml(schema.children)}
      </div>
      `
    } else {
      html += convertSchemaToHtml(schema.children)
    }
  } else {
    for (const el of schema) {
      switch (el.type) {
        case 'paragraph':
          html += buildParagraph(el)
          break
        case 'heading':
          html += buildHeading(el)
          break
        case 'list':
          html += buildList(el)
          break
        case 'list-item':
          html += buildListItem(el)
          break
        case 'link':
          html += buildLink(el)
          break
        case 'text':
          html += buildText(el)
          break
        default:
          break
      }
    }
  }
  return html
}

function buildParagraph(el) {
  if (el?.children) {
    return `<p>${convertSchemaToHtml(el?.children)}</p>`
  }
}

function buildHeading(el) {
  if (el?.children) {
    return `<h${el?.level}>${convertSchemaToHtml(el?.children)}</h${el?.level}>`
  }
}

function buildList(el) {
  if (el?.children) {
    if (el?.listType === 'ordered') {
      return `<ol>${convertSchemaToHtml(el?.children)}</ol>`
    } else {
      return `<ul>${convertSchemaToHtml(el?.children)}</ul>`
    }
  }
}

function buildListItem(el) {
  if (el?.children) {
    return `<li>${convertSchemaToHtml(el?.children)}</li>`
  }
}

function buildLink(el) {
  return `<a href="${el?.url}" title="${el?.title}" target="${
    el?.target
  }">${convertSchemaToHtml(el?.children)}</a>`
}

function buildText(el) {
  if (el?.bold) {
    return `<strong>${el?.value}</strong>`
  }
  if (el?.italic) {
    return `<em>${el?.value}</em>`
  }
  return el?.value
}

const NumberHelpers = {
	toPrice(price, toFixed = 2) {
		return (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: toFixed })
	},
	toPercentage(oldNumber, newNumber) {
		const decreaseValue = oldNumber - newNumber

		return ((decreaseValue / oldNumber) * 100).toFixed(0)
	}
}

const Helpers = {
	Number: NumberHelpers,
}